// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-contextmenu[data-v-2a4dc6e5] {\n  -webkit-transform-origin: center top;\n          transform-origin: center top;\n  z-index: 2190;\n  position: fixed;\n}\n.custom-contextmenu .el-dropdown-menu__item[data-v-2a4dc6e5] {\n  font-size: 12px !important;\n  white-space: nowrap;\n}\n.custom-contextmenu .el-dropdown-menu__item i[data-v-2a4dc6e5] {\n  font-size: 12px !important;\n}", ""]);
// Exports
module.exports = exports;
